import errorHandler from 'src/utils/error-handler';
import http from 'src/services/httpService';

const manager = {
  grantCardMetasItemTemporaryPermission: async (itemId) => {
    try {
      await http.post(`/CardMeta/ConcederPermissaoTemporariaItem`, {
        itemId: itemId,
      });
    } catch (error) {
      errorHandler(error);
    }
  },
};

export { manager };
